<app-header #header></app-header>
<app-breadcrumb></app-breadcrumb>
<div class="wrapper">
 <div class="row mat-z8">
  <div class="second-row w-100">
    <div class="heading">
      <div>Partnerships</div>
    </div>
    <div class="add-partnership">
      <button class="create-training btn custom_btn primary_btn_base" (click)="addTemplate()">
        <i class="fa fa-plus-circle  "></i>
        Create Partnership
      </button>
    </div>
  </div>
  <div class="total w-100">
    <table mat-table [dataSource]="dataSource" matSort class="m-1">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="logo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="alignment">Logo</th>
        <td mat-cell *matCellDef="let row">{{ row.logo }}</td>
      </ng-container>
      <ng-container matColumnDef="actions" class="style">
        <th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header>Actions</th>
        <td mat-cell *matCellDef="let row">{{ row.actions}}
          <div class="action-buttons">
            <button mat-icon-button (click)="toggleEditMode(); editRecord(row.id)">
              <span class="material-symbols-outlined">edit</span>
            </button>
            <button mat-icon-button (click)="deleteRecord(row.id)">
              <span class="material-symbols-outlined">delete</span>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
 </div>
</div>